export default {
  init() {
    // JavaScript to be fired on all pages
    
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('.flexnav').flexNav();
    $('a').click(function(){
      $('html, body').animate({
          scrollTop: $( $.attr(this, 'href') ).offset().top
      }, 500);
      return false;
    });
    $(".se-pre-con").delay(500).fadeOut("slow");
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js